import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createRewardPrograms(data) {
  return axiosInstance.post(`reward-programs/create`, formatRequest(data));
}

export function updateRewardPrograms(data) {
  return axiosInstance.post(`reward-programs/update`, formatRequest(data));
}

export function getRewardProgramsList(data) {
  return axiosInstance.post(`reward-programs/list`, formatRequest(data));
}

export function deleteRewardPrograms(data) {
  return axiosInstance.post(`reward-programs/delete`, formatRequest(data));
}

export function detailsRewardPrograms(data) {
  return axiosInstance.post(`reward-programs/details`, formatRequest(data));
}
